import { AuthContext, IToastContextProps, PopoverItem, ToastContext } from '@enter/core';
import { mdiAccountOutline } from '@mdi/js';
import copy from 'copy-text-to-clipboard';
import { inject, observer } from 'mobx-react';
import React, { useContext } from 'react';
import { IInjectedRootStore, RootStore } from '../../stores';
import * as S from './user-button.styles';

export const UserButton: React.FunctionComponent<IInjectedRootStore> = inject('rootStore')(
    observer((props: IInjectedRootStore) => {
        const { rootStore } = props;
        if (!rootStore) {
            return <></>;
        }
        const authContext = useContext(AuthContext);
        const toastContext = useContext(ToastContext);
        const renderButton = (): React.ReactElement => {
            return (
                <S.UserButton variant={rootStore.isLocal() ? 'fab-dark' : 'fab-light'}>
                    <S.StyledIcon path={mdiAccountOutline} />
                </S.UserButton>
            );
        };
        const handleLogout = (): void => {
            authContext.logoutAndRedirect && authContext.logoutAndRedirect();
        };
        const handleClick = (e: React.MouseEvent): void => {
            const { isDev } = rootStore;
            if (isDev() && e.ctrlKey && rootStore.userEmail) {
                copy(rootStore.userEmail);
                toastContext.notify && toastContext.notify('Copied to clipboard');
            }
        };
        return (
            <S.UserPopover align="right" renderButton={renderButton}>
                <S.PopoverNameItem disabled={true} selectable={false}>
                    <ToastContext.Consumer>
                        {(toast: IToastContextProps): React.ReactElement => (
                            <>
                                <S.UserField>{rootStore.userName}</S.UserField>
                                <S.UserValue onClick={handleClick}>{rootStore.userEmail}</S.UserValue>
                            </>
                        )}
                    </ToastContext.Consumer>
                </S.PopoverNameItem>
                {!!rootStore.account?.accountAccess && rootStore.account?.accountAccess?.length > 0 && (
                    <AccountsList rootStore={rootStore} />
                )}
                <S.StyledPopoverDivider />
                <S.PopoverLogoutItem onClick={handleLogout}>Log Out</S.PopoverLogoutItem>
            </S.UserPopover>
        );
    }),
);

export const AccountsList = observer(({ rootStore }: { rootStore: RootStore }) => {
    const context = useContext(AuthContext);
    const accounts = rootStore.account?.accountAccess;
    if (!accounts || accounts.length === 0) {
        return null;
    }

    const handleSwitchAccount = (accountId: string | undefined) => {
        return async () => {
            if (!accountId) {
                throw new Error('AccountID should be provided');
            }

            await context.switchAccount?.(accountId, '/');
        };
    };

    return (
        <div>
            <S.StyledPopoverDivider />
            {accounts.map(el => (
                <PopoverItem
                    onClick={handleSwitchAccount(el.accountId)}
                    disabled={el.accountId === rootStore.account?.grantedAccountId}>
                    {el.name}
                </PopoverItem>
            ))}
        </div>
    );
});
